import { AngularFirestore } from '@angular/fire/firestore';
import { Injectable } from '@angular/core';
import { Observable, Subscription } from 'rxjs';
import { AuthService } from './auth.service';

@Injectable({
  providedIn: 'root'
})
export class PermissionsService {
  cAdminType: any;
  _permissions: any;
  plist: Subscription;

  /** The one route gated by a named email list instead of a per-role flag. */
  static readonly PRINTER_CONFIG_ROUTE = 'printer-configuration';

  /** Where that list lives: document 'permissions' in collection 'System'. */
  private static readonly PERMISSIONS_DOC = 'System/permissions';
  private static readonly PRINTER_CONFIG_KEY = 'printerConfigurationPage';

  private currentEmail = '';

  constructor(private authService: AuthService, private afs: AngularFirestore) {
    this.authService.user.subscribe(userInfo=>{
      this.currentEmail = (userInfo && userInfo.email) ? userInfo.email : '';
      this.plist = this.afs.doc(`System/permissions/AdminSite/${userInfo.adminType}`).valueChanges().subscribe(res=>{
        this._permissions = res;
        console.log('Permissions loaded');
      });
    })
  }

  /**
   * Is this user allowed on the Printer Configuration page?
   *
   * Access is by the email allow-list in System/permissions.printerConfigurationPage,
   * not by the role flags every other route uses. Fails closed: a missing
   * document, a missing key, no signed-in email or a read error all deny.
   */
  isPrinterConfigAllowed(email?: string): Promise<boolean> {
    const target = String(email || this.currentEmail || '').trim().toLowerCase();
    if (!target) {
      console.warn('printerConfigurationPage: no signed-in email, access denied');
      return Promise.resolve(false);
    }

    return this.afs.doc(PermissionsService.PERMISSIONS_DOC).get().toPromise()
      .then(doc => {
        const exists = !!(doc && doc.exists);
        const data: any = exists ? doc.data() : null;
        const raw = data ? data[PermissionsService.PRINTER_CONFIG_KEY] : undefined;
        const allowList: any[] = Array.isArray(raw) ? raw : [];
        const allowed = allowList.some(
          (entry: any) => String(entry || '').trim().toLowerCase() === target);

        console.group('printerConfigurationPage');
        console.log('document        :', PermissionsService.PERMISSIONS_DOC,
                    exists ? '(found)' : '(NOT FOUND)');
        console.log('key             :', PermissionsService.PRINTER_CONFIG_KEY,
                    Array.isArray(raw) ? `(array, ${allowList.length} entries)`
                                       : `(not an array: ${JSON.stringify(raw)})`);
        console.log('emails in DB    :', allowList);
        console.log('signed-in email :', target);
        console.log(allowed ? 'RESULT: ALLOWED' : 'RESULT: DENIED');
        console.groupEnd();

        return allowed;
      })
      .catch(err => {
        console.error('printerConfigurationPage: read failed, access denied', err);
        return false;
      });
  }
}
